import { useEffect, useState } from 'react';
import { useFetch } from '@frontend/fetch';
import { ContentLoader } from '@frontend/design-system';
import { PortalDisabledPage } from '../atoms';
import { StripePaymentPortalStepper } from '../stripe-stepper';
import { PaymentsPortal } from '../switches';
import { PortalDisabledTypes } from '../types';

type StripePaymentPortalProps = PaymentsPortal.ProcessorSwitchProps;

export const StripePaymentPortal = ({
  amount,
  amountEditable = true,
  captchaToken,
  onSuccess,
  onFailure,
  origin,
  paymentConfig,
  portalData,
  refetchPortalData,
  showLocationInfo = true,
}: StripePaymentPortalProps) => {
  const { setLocationIdHeader } = useFetch();
  const [isEnabled, setIsEnabled] = useState(true);

  useEffect(() => {
    setLocationIdHeader(portalData?.locationData?.id);
  }, []);

  useEffect(() => {
    if (portalData?.locationData?.isPortalEnabled) {
      setIsEnabled(true);
    } else {
      setIsEnabled(false);
    }
  }, [portalData?.locationData?.isPortalEnabled]);

  if (!portalData?.onBehalfOf) return <ContentLoader show={true} />;

  return isEnabled ? (
    <StripePaymentPortalStepper
      amount={amount || portalData.amount}
      attachment={portalData?.attachment}
      captchaToken={captchaToken}
      locationData={portalData.locationData}
      onBehalfOf={portalData.onBehalfOf}
      onDisabled={() => setIsEnabled(false)}
      onFailure={onFailure}
      onSuccess={onSuccess}
      origin={origin}
      paymentConfigName={paymentConfig}
      person={portalData?.person}
      refetch={refetchPortalData}
      requestId={portalData.requestId}
      setupIntentId={portalData?.setupIntentId}
      settings={{
        ...portalData.settings,
        amountEditable,
        showLocationInfo,
      }}
    />
  ) : (
    <PortalDisabledPage
      locationData={portalData?.locationData}
      reason={!portalData.locationData?.isPortalEnabled ? PortalDisabledTypes.Disabled : PortalDisabledTypes.RateLimit}
    />
  );
};
